<template>
    <v-layout row wrap class="category-promo my-7">
        <v-flex xs12 sm6 v-for="item in items" :key="item.id" class="fill-height">
            <router-link :to="'/category/' + item.category">
                <v-img
                        :src="item.img"
                        aspect-ratio="2"
                        position="center center"
                        gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                >
                    <div class="image-caption white--text">
                        <div class="text-uppercase">{{ item.subtitle }}</div>
                        <h4>{{ item.title }}</h4>
                    </div>
                </v-img>
            </router-link>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: 'Promo',
        data () {
            return {
                items: [
                    {id: 1, title: 'Skvělé snídaně', subtitle: 'Vyzkoušejte', img: 'https://cdn.shortpixel.ai/client/q_glossy,ret_img,w_480,h_380/https://bistrocafe.online/wp-content/uploads/2020/04/joseph-gonzalez-fdlZBWIP0aM-unsplash-scaled-480x380.jpg', category: 'snidane'},
                    {id: 2, title: 'Dopřejte si', subtitle: 'Kávu', img: 'https://cdn.shortpixel.ai/client/q_glossy,ret_img,w_480,h_380/https://bistrocafe.online/wp-content/uploads/2020/04/annie-spratt-PM4Vu1B0gxk-unsplash-scaled-480x380.jpg', category: 'kava'},
                    {id: 3, title: 'Obědové menu', subtitle: 'Ochutnejte naše', img: 'https://cdn.shortpixel.ai/client/q_glossy,ret_img,w_761,h_500/https://bistrocafe.online/wp-content/uploads/2020/04/brooke-lark-jUPOXXRNdcA-unsplash-1-scaled-761x500.jpg', category: 'obedove-menu'},
                    {id: 4, title: 'Vitamínové koktejly', subtitle: 'Zdravé BIO', img: 'https://cdn.shortpixel.ai/client/q_glossy,ret_img,w_761,h_350/https://bistrocafe.online/wp-content/uploads/2020/04/ben-ashby-TAqEFzBEKbY-unsplash-scaled-761x350.jpg', category: 'vitaminove-kotejly'}
                ]
            }
        },
    }
</script>

<style lang="scss">
    .category-promo {
        .image-caption {
            bottom: 0;
            position: absolute;
            padding: 24px;
            h4 {
                font-size: 30px;
                font-weight: 600;
            }
        }
    }
</style>
